<template lang='pug' src='./smile-assurance-form.pug'></template>

<script>
// import api from 'api'
import axios from 'axios'
import { openModal, closeModal } from '@/methods'
export default {
  data: () => {
    return {
      checkboxgraphs: '',
      checkboxgraphs1: '',
      checkboxgraphs2: '',
      yourParentGuardian: '',
      postUrl: 'https://www.mattiacioortho.com/wp-json/rg-mail/v1/smileassurance',
      formSubmitted: false
    }
  },
  mounted: () => {
    let check1 = false
    let check2 = false
    let check3 = false

    const checkbox1 = document.getElementById('smile-checkbox1')
    const checkbox2 = document.getElementById('smile-checkbox2')
    const checkbox3 = document.getElementById('smile-checkbox3')

    if (checkbox1) {
      checkbox1.addEventListener('change', function () {
        check1 = this.checked
        check3 = false
        if (check1 === true || check2 === true && check3 === false) {
          document.getElementById('smile-checkbox-text').style.display = 'flex'
        } else {
          document.getElementById('smile-checkbox-text').style.display = 'none'
        }
        //  Missing unchecked
        document.getElementById('smile-checkbox3').checked = false
      })
    }

    if (checkbox2) {
      checkbox2.addEventListener('change', function () {
        check2 = this.checked
        check3 = false
        if (check1 === true || check2 === true && check3 === false) {
          document.getElementById('smile-checkbox-text').style.display = 'flex'
        } else {
          document.getElementById('smile-checkbox-text').style.display = 'none'
        }
        document.getElementById('smile-checkbox3').checked = false
      })
    }

    if (checkbox3) {
      checkbox3.addEventListener('change', function () {
        check3 = this.checked

        if (check1 === true && check2 === true && check3 === false) {
          document.getElementById('smile-checkbox-text').style.display = 'flex'
        } else {
          document.getElementById('smile-checkbox-text').style.display = 'none'
        }
        document.getElementById('smile-checkbox1').checked = false
        document.getElementById('smile-checkbox2').checked = false
      })
    }
  },
  mixins: [openModal, closeModal],
  methods: {
    validate () {
      this.onSubmit()
      /* this.$validator.validateAll()
      .then(result => {
        this.onSubmit()
        if (result) {
        }
      })
      .catch((e) => {
        console.log(e)
      }) */
    },
    onSubmit () {
      this.formSubmitted = true
      let check1 = this.$el.querySelector('[name="checkboxgraphs"]')

      if (check1 && check1.checked) {
        check1 = check1.value
      } else {
        check1 = ''
      }

      let check2 = this.$el.querySelector('[name="checkboxgraphs1"]')

      if (check2 && check2.checked) {
        check2 = check2.value
      } else {
        check2 = ''
      }

      let check3 = this.$el.querySelector('[name="checkboxgraphs2"]')

      if (check3 && check3.checked) {
        check3 = check3.value
      } else {
        check3 = ''
      }

      if (check1 === '' && check2 === '' && check3 === '') {
        alert('Please select one')
        this.formSubmitted = false
      } else {
        axios.post(this.postUrl, {
          checkboxgraphs: check1,
          checkboxgraphs1: check2,
          checkboxgraphs2: check3,
          yourParentGuardian: this.yourParentGuardian
        })
        .then(res => {
          this.formSubmitted = false
          this.openModal(1)
          setTimeout(() => {
            this.$el.children[0].reset()
          }, 500)
          this.closeModal(2)
          // this.openModal(1)
          window.location = '/feedback'
        })
        .catch(e => { console.log(e) })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// smile-assurance-form.vue?ecbdab22